<template>
  <div>
    <button
      @click="toggleMenu(itemId)"
      :aria-controls="`submenu-${itemId}`"
      aria-haspopup="true"
      :class="[
        { 'before:border-orange-light active': showActiveUnderline && !loginLink && !logoutLink },
        { 'btn-primary btn-small btn-icon-user text-base leading-3 ellevio-mega-menu-login-link  max-w-36 overflow-hidden whitespace-nowrap text-ellipsis': loginLink },
        { 'btn-primary btn-small text-base leading-3 ellevio-mega-menu-login-link max-w-[9rem] w-[100%] overflow-hidden whitespace-nowrap text-ellipsis inline-block': logoutLink },
        { 'animated-menu-link text-lg font-futuraEfBook items-start gap-2 rounded-sm text-left leading-6 flex': !loginLink && !logoutLink },
        { 'items-center': searchLink }
      ]"
      class="z-[999991] relative cursor-pointer sm:hide whitespace-nowrap ellevio-mega-menu-item-button"
      :aria-label="itemIsOpen ? `${ariaLabels?.closeMegaMenu} ${label}` : null"
      :aria-expanded="itemIsOpen"
      :id="itemId"
      :data-testid="loginLink || logoutLink ? 'nav-login-logout-button' : `desktopMenuButton-${itemId}`"
      role="menuitem"
      ref="menuButton">
      <span v-if="!loginLink && !logoutLink && !searchLink" class="hidden lg-large-rem:block">
        <ellevio-web-desktop-nav-lower-nav-icon v-if="!searchLink && itemIcon" :typeOfIcon="itemIcon" />
      </span>
      <ellevio-web-desktop-nav-lower-nav-icon v-if="searchLink" typeOfIcon="search" :data-testid="`desktopMegaMenuIconSmall-${itemId}`" />
      {{ label }}
    </button>
    <div v-show="itemIsOpen" @keydown.esc="closeAndSetButtonFocus()" class="fixed z-[99999] inset-0 flex flex-col w-full overflow-auto gray-gradient" :id="`submenu-${itemId}`" :aria-labelledby="itemId" :style="{ top: `${headerHeight}px` }">
      <div class="absolute top-0 left-0 right-0 gray-gradient h-14 md:h28" />
      <div class="bg-white">
        <nav :id="`trapping-box-${itemId}`" class="relative max-w-6xl pt-12 pb-16 m-auto px-desktop-gutter" ref="megaMenuRef">
          <div class="ellevio-mega-menu-sublinks">
            <Transition name="fade-slide">
              <div v-show="itemIsOpen">
                <slot></slot>
              </div>
            </Transition>
          </div>

          <button
            class="absolute flex items-center p-2 text-lg rounded-sm font-futuraEfBook hover:underline right-4 top-12 z-50]"
            :aria-label="`${ariaLabels.closeMegaMenu} ${label}`"
            @click="closeAndSetButtonFocus(itemId)"
            ref="closeBtnRef"
            :data-testid="`desktopMegaMenuCloseButton-${itemId}`">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="relative w-[0.875rem] h-[0.875rem] mr-2" :data-testid="`desktopMegaMenuCloseButtonIcon-${itemId}`">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5.72736 6.99994L0.000112799 1.27272L1.27284 0L7.00008 5.72722L12.7273 7.75299e-05L14 1.2728L1.27273 14L0 12.7273L5.72736 6.99994ZM12.7275 13.9993L8.01704 9.28883L9.28977 8.01611L14.0003 12.7266L12.7275 13.9993Z"
                fill="#2C2827" />
            </svg>
            <span class="inline-block">{{ ariaLabels?.closeMegaMenu }}</span>
          </button>
        </nav>
      </div>
      <div @click="toggleMenu(itemId)" class="ellevio-cursor-cross backdrop-blur bg-[rgba(44,40,39,0.4)] flex-1" :data-testid="`desktopMegaMenuBlurredBackdrop-${itemId}`"></div>
    </div>
  </div>
</template>

<script>
import EllevioWebDesktopNavLowerNavIcon from './DesktopNavLowerNavIcon.vue'
import { TrapFocus } from '../../../helpers/focusTrap.js'

export default {
  name: 'ellevio-web-desktop-nav-mega-menu-item',
  components: {
    EllevioWebDesktopNavLowerNavIcon
  },
  emits: ['toggleMegaMenu'],
  data() {
    return {}
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    itemId: {
      type: String,
      default: ''
    },
    itemIcon: {
      type: String,
      default: ''
    },
    searchLink: {
      type: Boolean,
      default: false
    },
    loginLink: {
      type: Boolean,
      default: false
    },
    logoutLink: {
      type: Boolean,
      default: false
    },
    itemIsOpen: {
      type: Boolean,
      default: false
    },
    showActiveUnderline: {
      type: Boolean,
      default: false
    },
    headerHeight: {
      type: Number,
      default: 0
    },
    scrollBarWidth: {
      type: Number,
      default: 0
    },
    ariaLabels: {
      type: Object,
      default: () => {
        return {
          closeMegaMenu: 'Stäng'
        }
      }
    }
  },
  mounted() {
    this.setMegaMenuPadding()
  },
  methods: {
    toggleMenu(itemId) {
      this.$emit('toggleMegaMenu', this.itemIsOpen ? '' : itemId)
    },
    closeAndSetButtonFocus() {
      this.toggleMenu('')
      this.$refs.menuButton.focus()
    },
    setMegaMenuPadding() {
      const megaMenuRef = this.$refs.megaMenuRef
      const closeBtnRef = this.$refs.closeBtnRef
      const megaMenuStyle = window.getComputedStyle(megaMenuRef)
      const closeBtnStyle = window.getComputedStyle(closeBtnRef)
      const megaMenuPaddingRight = parseInt(megaMenuStyle.paddingRight)
      const closeBtnRight = parseInt(closeBtnStyle.right)

      // Add scrollbar width to megamenu to position content correctly
      megaMenuRef.style.paddingRight = megaMenuPaddingRight + this.scrollBarWidth + 'px'
      closeBtnRef.style.right = closeBtnRight + this.scrollBarWidth + 'px'
    }
  },
  watch: {
    itemIsOpen() {
      this.$nextTick(() => {
        this.$nextTick(() => {
          if (this.itemIsOpen) {
            setTimeout(() => {
              document.querySelector('.vue-header').classList.add('!h-auto')
            }, 0)
            new TrapFocus(document.getElementById(`trapping-box-${this.itemId}`))
          } else {
            document.querySelector('.vue-header').classList.remove('!h-auto')
          }
        })
      })
    }
  }
}
</script>

<style scoped>
/* Antimation */
.fade-slide-enter-from {
  opacity: 0;
  transform: translateY(-1rem);
}
.fade-slide-enter-to {
  opacity: 1;

  transition: opacity 0.4s, transform 0.4s;
  transform: translateY(0);
}

/* All sublinks */
.ellevio-mega-menu-sublinks :deep(.ellevio-mega-menu-submenu a:not(.arrow-link-forward)) {
  @apply text-lg;
}

/* All links */
.ellevio-mega-menu-sublinks :deep(a:not(.arrow-link-forward)) {
  @apply hover:underline;
}

.ellevio-cursor-cross {
  cursor: url(../../../assets/images/cross-black-cursor.svg) 16 0, auto;
}
</style>
